









































































import {Component, Vue} from 'vue-property-decorator';
import PaginateButtons from '@/layouts/gripper/components/PaginateButtons.vue';
import {SmartQuery} from 'vue-apollo/types/vue-apollo';
import HotkeyListener from '@/layouts/gripper/hotkeys/HotkeyListener.vue';
import HotkeyLegend from '@/layouts/gripper/hotkeys/HotkeyLegend.vue';
import VueSimpleContextMenu from 'vue-simple-context-menu';
import {Jobs_jobs_data} from '@/types/intrador';
import {DashboardJobItem, RightClickMenuOptions} from '@/types/gripper';

@Component({
  components: {
    HotkeyListener,
    PaginateButtons,
    HotkeyLegend,
    VueSimpleContextMenu,
  },
  metaInfo: {
    title: 'JobDashboard',
  },
})
export default class Dashboard extends Vue {

  private jobs: Jobs_jobs_data[] = [];
  private items: DashboardJobItem[] = [];

  private selectedRowID: number | null = null;
  private page: number = 1;
  private limit: number = 25;
  private totalPages: number = 0;

  private search = '';
  private searchInput = '';

  private headers = [
    {
      text: 'Job ID',
      align: 'start',
      filterable: true,
      value: 'job_id',
    },
    {text: 'Dataset ID', value: 'dataset_id'},
    {text: 'Dataset Name', value: 'dataset_name'},
    {text: 'Task Name', value: 'task_name'},
    {text: 'Task Type', value: 'task_type'},
    {text: 'Status', value: 'status'},
    {text: 'Progress', value: 'progress'},
  ];

  private rightClickMenuOptions: RightClickMenuOptions[] = [
    {
      name: 'Go to dataset',
      slug: 'go_to_dataset',
    },
    {
      name: 'Go to task',
      slug: 'go_to_task',
    },
    {
      name: 'Go to job',
      slug: 'go_to_job',
    },
    {
      name: 'Go to parameter',
      slug: 'go_to_parameter',
    },
  ];

  private onRightClickMenuEntryClick(method: any, item: any) {
    const clickedJob: Jobs_jobs_data = this.jobs[method.item.index];
    if (clickedJob) {
      if (method.option.slug === 'go_to_dataset') {
        const url = new URL('/nova/resources/datasets/'
          + clickedJob.dataset!.id, process.env.VUE_APP_API_DOMAIN!).href;
        window.open(url, '_blank');
      } else if (method.option.slug === 'go_to_task') {
        const url = new URL('/nova/resources/tasks/'
          + clickedJob.task!.id, process.env.VUE_APP_API_DOMAIN!).href;
        window.open(url, '_blank');
      } else if (method.option.slug === 'go_to_job') {
        const url = new URL('/nova/resources/jobs/'
          + clickedJob.id, process.env.VUE_APP_API_DOMAIN!).href;
        window.open(url, '_blank');
      } else if (method.option.slug === 'go_to_parameter') {
        const url = new URL('/nova/resources/parameters/'
          + clickedJob.task!.parameter.id, process.env.VUE_APP_API_DOMAIN!).href;
        window.open(url, '_blank');
      }
    }
  }

  private rightClickHandler(event: any, item: any) {
    (this.$refs.rightClickMenu as any).showMenu(event, item);
  }

  private resolveData(data: any) {
    this.items = [];
    this.totalPages = Math.ceil(data.jobs.paginatorInfo.total / this.limit);
    this.jobs = data.jobs.data;


    this.jobs.forEach((job: any) => {
      this.items.push({
        job_id: job.id,
        dataset_id: job.dataset.id,
        dataset_name: job.dataset.name,
        task_name: job.task.name,
        task_type: this.determineTaskType(job.task.type),
        status: this.checkStatus(job),
        progress: job.resources_done + '/' + job.resources_total,
      } as DashboardJobItem);
    });
  }

  private determineTaskType(taskType: any) {
    switch (taskType) {
      case 'quick_labelling':
        return 'Quick Labelling';
      case 'single_labelling':
        return 'Single Picture';
      case 'mask_point':
        return 'Segmentation with points';
      case 'mask_brush':
        return 'Segmentation with brush';
    }
  }

  private async pageChange(newPage: number) {
    this.page = newPage;
    this.jobs = [];
    await this.refetch();
  }

  private async refetch() {
    if (this.queryResult) {
      await this.queryResult.fetchMore({
        variables: this.queryVariables,
        updateQuery: (prev, {fetchMoreResult}) => {
          if (!fetchMoreResult) {
            return prev;
          }
          return {
            ...fetchMoreResult,
          };
        },
      });
    }
  }

  private get queryResult(): SmartQuery<any> {
    return (this.$refs.jobs as any).getApolloQuery();
  }

  get queryVariables() {
    return {
      whereSearch: this.search,
      page: this.page,
      limit: this.limit,
    };
  }

  private clickRow(job: any) {
    this.$router.push({
      name: 'job',
      params: {
        jobID: job.job_id,
      },
      query: {},
    });
  }

  private checkStatus(job: any) {
    if (job.resources_done === 0) {
      return 'New';
    } else if (job.resources_done === job.resources_total) {
      return 'Done';
    }
    return 'In Progress';
  }

}
